import styled from "styled-components";
import Button from "components/Buttons/ThemeButton";
import { LoyaltyPointsV2 } from "styles/general_styles";

export const Container = styled.div`
	//display: grid;
	grid-template-rows: auto;
	background-color: rgba(51, 51, 51, 0.6);
	border: 1px solid #9aeffc;
	border-radius: 12px;
	padding: 0.5em;
	gap: 0.5em;
	margin: 0.1875em;
	width: 12.5em;
	height: auto;
	z-index: 999;
	align-content: stretch;

	&.bouncy-chest {
		background-color: rgba(0, 0, 0, 0.5);
	}

	@media (orientation: portrait) {
		font-size: 17px;
		width: 90%;
		&.one-item {
			min-width: unset;
			img {
				width: 4.625em;
				height: 4.625em;
			}
			&.bouncy-chest {
				img {
					width: 85px;
					height: 85px;
				}
			}
		}
		&.two-items {
			min-width: 15.625em;
			img {
				width: 4.375em;
				height: 4.375em;
			}
		}
		&.several-items {
			img {
				width: 100%;
				height: 4.375em;
			}
			min-width: 12.5em;
		}
	}
	@media (orientation: landscape) {
		gap: 1.2em;
		img {
			width: 3.9em;
			height: 3.9em;
		}
		&.one-item {
			min-width: 25em;
			width: auto;

			&.bouncy-chest {
				width: 400px;
				img {
					width: 75px;
					height: 75px;
				}
			}
		}
		&.two-items {
			min-width: 21.875em;
		}
		&.several-items {
			min-width: 18.75em;
		}
	}
`;

export const Items = styled.div`
	justify-content: center;
	align-items: end;
	display: flex;
	flex-wrap: wrap;
`;
/* eslint-disable */
export const RewardItem = styled.div<any>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	padding: 0.0625em;
	//gap: 0.4rem;

	&.bouncy-chest {
		position: relative;
		padding: 6px;
	}
`;
/* eslint-enable */

export const RewardAmountContainer = styled.div`
	&.bouncy-chest {
		position: absolute;
		min-width: 42%;
		display: flex;
		align-items: center;
		justify-content: center;
		bottom: -10px;
	}
`;

export const RewardAmount = styled.div`
	color: #fff;
	font-weight: 700;
	font-size: 1em;

	&.bouncy-chest {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: right;
		font-family: "Baloo";
		font-weight: 300;
		font-size: 28px;
		text-shadow: 0 0 3px #000000, 0 0 4px #000000, 0 0 4px #000000,
			0 0 3px #000000;
	}

	@media (orientation: landscape) {
		&.bouncy-chest {
			font-size: 26px;
		}
	}
`;

export const ItemImage = styled.img`
	width: 46px;
	height: 46px;
	object-fit: contain;
	justify-self: center;
	align-self: center;
`;

export const Footer = styled.div`
	display: grid;
	align-items: center;
	button {
		padding: 0.5rem 0.2rem;
		gap: 0.4rem;
	}

	&.one-item {
		margin-top: 0.4em;
	}

	&.loyalty-reward {
		grid-template-columns: auto auto;
		grid-gap: 0.6em;

		&.bouncy-chest {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			grid-gap: 2px;
			width: 100%;
		}

		@media (orientation: portrait) {
			grid-template-columns: auto 45%;
			&.one-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 100%;
				button {
					width: 100%;
				}

				&.bouncy-chest {
					flex-direction: column;
				}
			}
		}
	}
`;

export const CustomLoyaltyPointsV2 = styled(LoyaltyPointsV2)`
	font-size: 1em;
	min-height: 1.5em;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	line-height: auto;
	padding: 0.2em 0.8em;
	gap: 0.1em;
`;

export const LoyaltyValue = styled.div`
	font-size: 0.9em;
	line-height: 0.9em;
`;

export const LoyaltyPoints = styled.div`
	background-color: rgba(0, 0, 0, 0.51);
	color: #fff;
	font-size: 0.9em;
	padding: 0.5em 0.8em;
	margin: 0.3em 0em;
	border-radius: 100px;

	> div {
		align-items: center;
		justify-content: center;
		display: flex;
		gap: 0.2em;
	}
`;

export const OfferText = styled.div`
	font-family: "Inter", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #ffffffff;
	line-height: 18px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (orientation: landscape) {
		font-size: 12px;
	}
`;

export const BouncyChestButton = styled(Button)`
	margin-top: 10px;
	width: 94%;
	font-size: 22px;
	height: 66px;

	@media (orientation: landscape) {
		width: 70%;
		font-size: 20px;
		height: 58px;
	}
`;
